module.exports = __webpack_public_path__ + "img/symbol_8.3ecd2702.png";